import { EnumTypeValue } from "@/shared/types";

export const ActieStatus = {
    NIEUW: "Nieuw",
    GEACCEPTEERD: "Geaccepteerd",
    GEWEIGERD: "Geweigerd",
} as const;
export type ActieStatus = EnumTypeValue<typeof ActieStatus>;

export const VestigingActieType = {
    VESTIGINGEN_AANGEVRAAGD: "VestigingenAangevraagd",
    VESTIGINGEN_STOP_AANGEVRAAGD: "VestigingenStopAangevraagd",
    VESTIGINGEN_VERLENGING_AANGEVRAAGD: "VestigingenVerlengingAangevraagd",
} as const;
export type VestigingActieType = EnumTypeValue<typeof VestigingActieType>;

export const VestigingActieMessages = {
    VestigingenAangevraagd: {
        titel: "Faciliteiten aangevraagd",
        beschrijving: "De regievoerder heeft faciliteiten aangevraagd",
        actieTekst: "Bekijk openstaande aanvragen",
    },
    VestigingenStopAangevraagd: {
        titel: "Stop faciliteiten aangevraagd",
        beschrijving: "De regievoerder verzoekt faciliteiten te stoppen",
        actieTekst: "Bekijk openstaande aanvragen",
    },
    LandelijkeFaciliteitenAangevraagd: {
        titel: "Landelijke faciliteiten aangevraagd",
        beschrijving: "De regievoerder heeft landelijke faciliteiten aangevraagd",
        actieTekst: "Bekijk aanvraag landelijke faciliteiten",
    },
    LandelijkeFaciliteitenStopAangevraagd: {
        titel: "Stop landelijke faciliteiten aangevraagd",
        beschrijving: "De regievoerder verzoekt landelijke faciliteiten te stoppen",
        actieTekst: "Bekijk aanvraag landelijke faciliteiten",
    },
    VestigingenVerlengingAangevraagd: {
        titel: "Verlenging openingstijden aangevraagd",
        beschrijving: "De regievoerder verzoekt openingstijden te verlengen",
        actieTekst: "Bekijk openstaande aanvragen",
    },
} as const;

export const ACTIES_QUERY_KEY = "acties";
